<template>
    <div class="IperMatrizPeligrosMatriz">
        <!-- EMPRESA -->
        <div v-if="propiedades.column.field === 'empresa'" class="mt-2">
            <Empresa :empresa="propiedades.row.empresa" />
        </div>

        <!-- SECTOR -->
        <div v-else-if="propiedades.column.field === 'sector'" class="mt-2">
            <Sector :sector="propiedades.row.sector" />
        </div>

        <!-- CENTRO DE TRABAJO -->
        <div v-else-if="propiedades.column.field === 'centroTrabajo'" class="mt-2">
            <CentroTrabajo :centroTrabajo="propiedades.row.centroTrabajo" />
        </div>

        <!-- REGIONAL -->
        <div v-else-if="propiedades.column.field === 'regional'" class="mt-2">
            <Regional :regional="propiedades.row.regional" />
        </div>

        <!-- DIRECCION -->
        <div v-else-if="propiedades.column.field === 'direccion'" class="mt-2">
            <Direccion :direccion="propiedades.row.direccion" />
        </div>

        <!-- DEPARTAMENTO -->
        <div v-else-if="propiedades.column.field === 'departamento'" class="mt-2">
            <Departamento :departamento="propiedades.row.departamento" />
        </div>

        <!-- CIUDAD -->
        <div v-else-if="propiedades.column.field === 'ciudad'" class="mt-2">
            <Ciudad :ciudad="propiedades.row.ciudad" />
        </div>

        <!-- FECHA -->
        <div v-else-if="propiedades.column.field === 'actualizacion'" class="mt-2">
            <Fecha :fecha="propiedades.row.actualizacion" />
        </div>

        <!-- ESTADO -->
        <div v-else-if="propiedades.column.field === 'estadoActivo'" class="mt-2">
            <EstadoActivo :estado="propiedades.row.estadoActivo" />
        </div>

        <!-- OPCIONES -->
        <div v-else-if="propiedades.column.field === 'opciones'" class="mt-2">
            <Opciones :matriz="propiedades.row" />
        </div>
    </div>
</template>

<script>
import Empresa from './Empresa/Empresa.vue';
import Sector from './Sector/Sector.vue';
import CentroTrabajo from './CentroTrabajo/CentroTrabajo.vue';
import Regional from './Regional/Regional.vue';
import Direccion from './Direccion/Direccion.vue';
import Departamento from './Departamento/Departamento.vue';
import Ciudad from './Ciudad/Ciudad.vue';
import Opciones from './Opciones/Opciones.vue';
export default {
    name: "IperMatrizPeligrosMatriz",

    components: {
        Empresa,
        Sector,
        CentroTrabajo,
        Regional,
        Direccion,
        Departamento,
        Ciudad,
        Opciones,
    },

    props: {
        propiedades: Object
    },
}
</script>